import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { GlobalErrorView } from '@bingads-webui-react/app-global-error-view';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const isIE11 = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);

function getHelpContentHref(i18nLocale) {
  const splits = i18nLocale.split('-');
  let localeCode = splits[0] || 'en';

  if (localeCode === 'pt') {
    localeCode = 'pt-BR';
  }

  return `https://help.ads.microsoft.com/#apex/ads/${localeCode}/52033/0`;
}

export const DefaultGlobalErrorView = ({ isUnifiedProduct }) => {
  const i18n = useContext(I18nContext);
  const appName = isUnifiedProduct ? 'Microsoft Advertising' : 'Digital Marketing Center';
  const title = i18n.getString(isIE11 ? _TL_('The site is incompatible with your browser') : _TL_('Well, that\'s unexpected'));
  const contactUs = useCallback(() => (
    isUnifiedProduct
      ? <a href="http://go.microsoft.com/fwlink/?LinkId=258669" rel="noopener noreferrer" target="_blank">{i18n.getString(_TL_('Contact Us - Microsoft Advertising'))}</a>
      : <a href="https://go.microsoft.com/fwlink?LinkID=2115308" rel="noopener noreferrer" target="_blank">{i18n.getString(_TL_('Contact Us - Digital Marketing Center'))}</a>
  ), [i18n, isUnifiedProduct]);

  const description = useMemo(() => {
    const descriptions = i18n.getString(_TL_('Please find the list of supported browsers on {0}')).split('{0}');

    if (isIE11) {
      return [
        () => (
          <p>
            {descriptions[0]}
            <a href={getHelpContentHref(i18n.getLocale())}>{i18n.getString(_TL_('this page'))}</a>
            {descriptions[1]}
          </p>
        ),
      ];
    }

    return [
      i18n.getString(_TL_("{{appName}} isn't available right now, but everything should be back to normal very soon."), { appName }),
      i18n.getString(_TL_("Don't worry about your ads - this doesn't impact them.")),
      contactUs,
      () => <a href={window.location.href}>{i18n.getString(_TL_('Refresh Page'))}</a>,
    ];
  }, [i18n, appName, contactUs]);

  const errorViewProps = {
    className: 'error-page',
    title,
    description,
  };
  return <GlobalErrorView {...errorViewProps} />;
};

DefaultGlobalErrorView.propTypes = {
  isUnifiedProduct: PropTypes.bool,
};

DefaultGlobalErrorView.defaultProps = {
  isUnifiedProduct: true,
};
